import React, { useState } from 'react';
import UserStore from 'stores/UserStore';
import { Button, message, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const { Text } = Typography;

interface IProps {
    id: number;
}

const Send: React.FC<IProps> = props => {
    const [clicked, setClicked] = useState<boolean>(false);

    const handleClick = () => {
        setClicked(true);
        UserStore.verifyOtherEmail(props.id)
            .then(() => {})
            .catch(() => {
                message.error('Error');
            });
    };

    return (
        <>
            {!clicked ? (
                <Button type="link" className="font-size-sm text-primary m-0 p-0" onClick={handleClick}>
                    Resend Verification Email
                </Button>
            ) : (
                <Text type="success" className="font-size-sm">
                    <CheckCircleFilled className="mr-1" />
                    Verification Email Sent
                </Text>
            )}
        </>
    );
};

export default Send;
